// extracted by mini-css-extract-plugin
module.exports = {"confirmedCases":"ConfirmedCases_confirmedCases__2sWEY","countryCases":"ConfirmedCases_countryCases__3QGhj"};